import React from "react";
import AdminDataContainer from "@commr/admin/components/admins/adminDataContainer";
import { Admin } from "@commr/admin/models/user/admin/admin";

const AddAdminPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <AdminDataContainer admin={new Admin()} isSuper />
);

export default AddAdminPage;
